import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["page", "limit"],
  _excluded2 = ["data", "isLoading"];
import * as React from 'react';
import { useQueryClient } from 'react-query';
import { useQuery } from '../crud';
import { useAxiosClient } from '../hooks';
export function useResourceData(resource, params, queryOptions) {
  var _queryOptions$placeho, _queryOptions$placeho2;
  const [totalSizePlaceholder, setTotalSizePlaceholder] = React.useState((_queryOptions$placeho = queryOptions == null ? void 0 : (_queryOptions$placeho2 = queryOptions.placeholderData) == null ? void 0 : _queryOptions$placeho2.totalSize) != null ? _queryOptions$placeho : 0);
  const queryClient = useQueryClient();
  const axiosService = useAxiosClient();
  const key = [resource, params];
  async function queryFn() {
    var _response$headers, _response$data$respon;
    const {
        page,
        limit
      } = params,
      restParams = _objectWithoutPropertiesLoose(params, _excluded);
    const firstData = +page * +limit;
    const lastData = +page * +limit + (+limit - 1);
    const headers = {
      'content-range': `${firstData}-${lastData}`
    };
    const response = await axiosService.get(`/v2/${resource}`, {
      params: restParams,
      headers
    });
    const contentRangeArray = (((_response$headers = response.headers) == null ? void 0 : _response$headers['content-range']) || '').split('/');
    const totalSize = +contentRangeArray[contentRangeArray.length - 1];
    return {
      data: (_response$data$respon = response.data.response) != null ? _response$data$respon : [],
      totalSize
    };
  }
  const _useQuery = useQuery(key, queryFn, _extends({
      staleTime: 2
    }, queryOptions || {}, {
      onSuccess: res => {
        var _queryOptions$onSucce;
        setTotalSizePlaceholder(res.totalSize);
        const newParam = _extends({}, params, {
          page: +params.page + 1
        });
        if (!(res.data.length < +params.limit)) {
          queryClient.prefetchQuery([resource, newParam], queryFn);
        }
        queryOptions == null ? void 0 : (_queryOptions$onSucce = queryOptions.onSuccess) == null ? void 0 : _queryOptions$onSucce.call(queryOptions, res.data);
      },
      onError: queryOptions == null ? void 0 : queryOptions.onError,
      onSettled: (res, err) => {
        var _queryOptions$onSettl;
        return queryOptions == null ? void 0 : (_queryOptions$onSettl = queryOptions.onSettled) == null ? void 0 : _queryOptions$onSettl.call(queryOptions, res == null ? void 0 : res.data, err);
      }
    })),
    {
      data = {
        data: [],
        totalSize: totalSizePlaceholder
      },
      isLoading
    } = _useQuery,
    queryResult = _objectWithoutPropertiesLoose(_useQuery, _excluded2);
  return _extends({
    data,
    isLoading
  }, queryResult);
}